<template>
  <div class="one-column-view">
    <div class="article-content">
      <img
        src="../../assets/Goldenlink-comparison.png"
        alt="Traffic Mining Entries"
      />
      <img
        src="../../assets/Early-Stage-GSG-Minership.png"
        alt="Early Stages in GSG Entry"
      />
      <p>
        如果您想提高这一价值，可以考虑将其铸造成流量和品牌币（GSCoin和GLC）。在接受加密货币的国家可以选择这种方式。
      </p>
      <h1>挖矿和盈利结果</h1>
      <p>
        下图显示了进入GSG的挖矿收益和奖励。
      </p>
      <img src="../../assets/EarningsAndRewards.png" alt="Earnings And Rewards" />
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped></style>
